import CacheableJson from '../CacheableJson';

class GlobalNotifications extends CacheableJson {
	get url() {
		return 'nrl/notification-bar-classic.json';
	}
}

export default GlobalNotifications;